<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { IconSize } from '~/utils/icon'
import { NuxtLink } from '#components'

export interface ControlButtonProps {
  selected?: boolean
  size?: ButtonSize
  icon?: IconDefinition
  type?: 'filled' | 'outlined' | 'ghost'
  href?: string
  to?: RouteLocationRaw
  toggleSelected?: boolean
  pinned?: boolean
  iconSize?: IconSize
}

withDefaults(
  defineProps<ControlButtonProps>(),
  {
    size: 'large',
    type: 'filled',
    href: undefined,
    to: undefined,
    toggleSelected: true,
    pinned: false,
    iconSize: undefined,
  },
)
</script>

<template>
  <component
    :is="$attrs.disabled ? 'button' : $attrs.type === 'label' ? 'label' : href ? 'a' : to ? NuxtLink : 'button'"
    type="button"
    :href="href"
    :to="to"
    :aria-disabled="$attrs.disabled"
    :class="buttonVariants.control.base({ selected, size, type, pinned, iconOnly: $slots.default === undefined })"
  >
    <slot />
    <Icon v-if="icon" :icon="icon" :size="iconSize ?? (size === 'xsmall' || size === 'small' ? 'sm' : 'md')" />
  </component>
</template>
